(ns ui.view.transaction-process.cards.field-card
  "The one generic card type. Renders an ordered, heterogeneous
   `:card/fields` list — scalar/keyword fields and attachment-slot fields freely
   interleaved — dispatching each by its data-type: attachment-slots render as an
   upload dropzone, everything else as a labelled input."
  (:require
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.state.session.sub :as session-sub]
   [ui.view.transaction-process.cards.card-header :as card-header]
   [ui.view.transaction-process.cards.document-upload :as doc]
   [ui.view.transaction-process.cards.property-list :as property-list]
   [ui.view.transaction-process.sub :as sub]
   [ui.view.transaction-process.util :as tp-util]
   [ui.util :as uu]))

(defn- attachment-slot-field-cell
  [{:keys [field-kw field-config mandatory? permission attachments process-id
           read-only? uploading-atom]}]
  [doc/slot-section
   {:slot-id        field-kw
    :slot-label     (:field/label field-config)
    :mandatory?     (boolean mandatory?)
    :multiple?      (:field/multiple? field-config)
    :attachments    (filterv #(contains? (set (:common/system-kws %)) field-kw) attachments)
    :process-id     process-id
    :read-only?     (or read-only? (= permission :r))
    :uploading-atom uploading-atom}])

(defn view
  [_props]
  (let [uploading-atom (r/atom [])]
    (fn [{:keys [card entity-data ctx process-id]}]
      (let [visible-fields @(rf/subscribe [::sub/visible-fields ctx (:card/fields card)])]
        (when (seq visible-fields)
          (let [attachments (doc/get-attachments entity-data)
                read-only?  @(rf/subscribe [::session-sub/read-only-user?])]
            [:div {:class "bg-white rounded-lg border border-gray-200 p-6"}
             [card-header/view {:card card}]
             [:div {:class "grid grid-cols-2 gap-x-6 gap-y-4"}
              (doall
               (for [{:keys [field-kw field-config permission mandatory? calculated?]} visible-fields]
                 ^{:key field-kw}
                 [:div {:class (uu/cm "flex flex-col justify-end"
                                      (when (or (:field/full-width field-config)
                                                (tp-util/attachment-slot-field? field-config)
                                                (= :data.type/text-multiline (:field/data-type field-config)))
                                        "col-span-2"))}
                  (cond
                    (tp-util/attachment-slot-field? field-config)
                    [attachment-slot-field-cell
                     {:field-kw       field-kw
                      :field-config   field-config
                      :mandatory?     mandatory?
                      :permission     permission
                      :attachments    attachments
                      :process-id     process-id
                      :read-only?     read-only?
                      :uploading-atom uploading-atom}]

                    calculated?
                    [property-list/read-only-field
                     {:field-kw     field-kw
                      :field-config field-config
                      :entity-data  entity-data}]

                    :else
                    [:<>
                     [property-list/field-row
                      {:ctx          ctx
                       :field-kw     field-kw
                       :field-config field-config
                       :entity-data  entity-data
                       :permission   permission
                       :mandatory?   mandatory?}]
                     [property-list/field-notice
                      {:field-config field-config
                       :entity-data  entity-data}]])]))]]))))))
